import { useTranslation } from "react-i18next";
import vconst from "utils/helpers/structs/vconst"

const ObjectStatusIcon = ({status, objectFinished = null}) => {
    const { t } = useTranslation(['Objects']);
    const classes = {
        [vconst.objectInWork]       : 'bi bi-play-circle fs-18 text-success',
        [vconst.objectFinishedTeam] : 'bi bi-check-circle fs-18 text-success',
        [vconst.objectFinished]     : 'bi bi-check-circle-fill fs-18 text-success',
        [vconst.objectReject]       : 'bi bi-x-circle-fill fs-18 text-danger',
        [vconst.objectPanding]      : 'bi bi-pause-circle fs-14 fs-18 text-warning',
    }

    return (
         <i className={classes[status]}
            title={`${t(`status.${status}`)}${objectFinished ? `: ${objectFinished}` : ''}`}></i>  
         )

}

export default ObjectStatusIcon; 